import React from 'react'
import { Progress, Table, Tag, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { IMovementRS } from '../../../../models/storageModel'
import { groupMovementsByType, isEntryMovement, isExitMovement, TGroupedData } from '../../../../utils/reportUtils'
import { TExcelColumn } from '../../../../utils/excelExport'
import { textNumberFormater } from '../../../../utils'

const { Text } = Typography

interface MovementsByTypeReportProps {
  data: IMovementRS[]
  loading?: boolean
}

export const typeExcelColumns: TExcelColumn[] = [
  { header: 'Tipo Movimiento (Código)', key: 'key', width: 25 },
  { header: 'Tipo Movimiento (Nombre)', key: 'label', width: 30 },
  { header: 'Nº Movimientos', key: 'count', width: 16, format: 'number' },
  { header: 'Monto Total', key: 'totalAmount', width: 18, format: 'money' },
  { header: '% Participación', key: 'percentage', width: 16, format: 'percent' }
]

export function getTypeExcelData(data: IMovementRS[]) {
  return groupMovementsByType(data)
}

export const MovementsByTypeReport: React.FC<MovementsByTypeReportProps> = ({ data, loading = false }) => {
  const groupedData = groupMovementsByType(data)

  const columns: ColumnsType<TGroupedData> = [
    {
      title: '#',
      key: 'index',
      width: 50,
      render: (_, __, index) => index + 1
    },
    {
      title: 'Tipo de Movimiento',
      dataIndex: 'label',
      key: 'label',
      render: (text, record) => {
        let color = 'default'
        if (isEntryMovement(record.key)) color = 'green'
        else if (isExitMovement(record.key)) color = 'red'
        else if (record.key === 'TRANSFER') color = 'blue'
        return <Tag color={color} style={{ fontSize: '0.85rem', padding: '2px 8px' }}>{text}</Tag>
      }
    },
    {
      title: 'Nº Movimientos',
      dataIndex: 'count',
      key: 'count',
      width: 140,
      align: 'right',
      sorter: (a, b) => a.count - b.count,
      render: (count) => textNumberFormater(count)
    },
    {
      title: 'Monto Total',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      width: 180,
      align: 'right',
      sorter: (a, b) => a.totalAmount - b.totalAmount,
      render: (val) => <Text strong style={{ color: '#1890ff' }}>$ {textNumberFormater(val)}</Text>
    },
    {
      title: '% Participación',
      dataIndex: 'percentage',
      key: 'percentage',
      width: 220,
      sorter: (a, b) => a.percentage - b.percentage,
      render: (pct) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Progress percent={pct} size="small" strokeColor="#1890ff" style={{ flex: 1, margin: 0 }} />
          <span style={{ width: 45, textAlign: 'right', fontSize: '0.85rem' }}>{pct}%</span>
        </div>
      )
    }
  ]

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <Table<TGroupedData>
        columns={columns}
        dataSource={groupedData}
        loading={loading}
        pagination={false}
        size="small"
        bordered
        scroll={{ x: 'max-content' }}
      />
    </div>
  )
}

export default MovementsByTypeReport
